<script setup lang="ts">
import { ref, type PropType } from 'vue';
import { ButtonType, CustomButton } from '@/components/common/';
import type { CaseModel } from '@/models';
import { useStudyStore } from '@/stores/study';
import PerfusionScanQrDialog from './PerfusionScanQrDialog.vue';

const props = defineProps({
  caseModel: {
    type: Object as PropType<CaseModel>,
    required: true
  },
  showText: {
    type: Boolean,
    default: false
  }
});

const studyStore = useStudyStore();
const showQrDialog = ref(false);

const openDialog = (event: MouseEvent) => {
  event.stopPropagation();
  showQrDialog.value = true;
};
</script>

<template>
  <div class="perfusion-scan-root" @click.stop>
    <CustomButton :icon="{ icon: 'qrcode', style: 'fal' }"
      :type="ButtonType.ICON_ONLY"
      tooltip="Perfusion scan"
      v-if="!showText"
      @onClick="openDialog"/>

    <CustomButton :icon="{ icon: 'qrcode', style: 'far' }"
      :type="ButtonType.OUTLINED"
      text="Scan"
      v-if="showText"
      @onClick="openDialog"/>

    <PerfusionScanQrDialog v-model:visible="showQrDialog"
      :pump-center-id="studyStore.selectedStudyId ?? studyStore.selectedStudy?.identifier ?? ''"
      :study-title="studyStore.selectedStudy?.title ?? ''"
      :perfusion-id="props.caseModel.identifier"
      :perfusion-label="props.caseModel.label"/>
  </div>
</template>

<style scoped lang="scss">
.perfusion-scan-root {
  display: inline-flex;
  align-items: center;
}

:deep(.icon-only) {
  padding: unset;
  min-width: unset;
}
</style>
